<a _ngcontent-c2="" class="menu-close item" (click)="closeSidebar()">
<span class="sr-only">Close main menu</span>
<span _ngcontent-c2="" class="fa fa-close" aria-hidden="true"></span>
</a>
<div _ngcontent-c2="" class="item banner">
<i _ngcontent-c2="" class="user icon"></i>
  <span _ngcontent-c2="">tommygogd@gmail.com</span>
</div>

<!---->
<!---->

<!----><a _ngcontent-c2="" class="item active" href="/dashboard">

  Dashboard
</a>
<!----><div _ngcontent-c2="" class="item">
  Name Reservation
  <div _ngcontent-c2="" class="menu">
    <a _ngcontent-c2="" class="item" href="/name-reservation/applications">
      My Reservations
    </a>
    <a _ngcontent-c2="" class="item" href="/name-reservation/application">
      New Name Reservation
    </a>
  </div>
</div>
<!----><span _ngcontent-c2="" class="item">
  Company Registration
  <div _ngcontent-c2="" class="menu">
    <a _ngcontent-c2="" class="item" href="/company-registration/applications">
      My Registrations
    </a>
    <div _ngcontent-c2="" class="divider"></div>
    <a _ngcontent-c2="" class="item" href="/company-registration/application">
      New Registration
    </a>
  </div>
</span>



<!----><a _ngcontent-c2="" class="item" href="/edit-profile">
  <i _ngcontent-c2="" class="edit icon"></i>Edit Profile</a>
<!----><a _ngcontent-c2="" class="item" href="/change-password">
  <i _ngcontent-c2="" class="lock icon"></i>Change Password</a>
<!----><a _ngcontent-c2="" class="item">
  <i _ngcontent-c2="" class="sign out icon"></i>Logout</a>

<a _ngcontent-c2="" class="item" href="/complaint">
  <i _ngcontent-c2="" class="help icon"></i>Help</a>
<a _ngcontent-c2="" class="item" href="/faq">FAQ</a>
<a _ngcontent-c2="" class="item" href="/contact-us">Contact Us</a>

